import dayjs from 'dayjs';

export const getCurrentPageSelectedKeys = (
  data: any[],
  selection: any,
  rowKey: string,
) => {
  if (selection.isSelectAll) {
    return data.filter(t => !selection.excludedKeys?.includes(t[rowKey])).map(t => t[rowKey]);
  }
  if (selection.includedKeys?.length) {
    return data.filter(t => selection.includedKeys?.includes(t[rowKey])).map(t => t[rowKey]);
  }
  return [];
};

export const onSelectedKeysChange = (
  data: any[],
  newKeys: any[],
  selection: any,
  setSelection: (_: any) => any,
  rowKey: string,
) => {
  const next = { ...selection };
  if (selection.isSelectAll) {
    const set = new Set([
      ...next.excludedKeys.filter((id: any) => !newKeys.includes(id)),
      ...data.map(t => t[rowKey]).filter((id: any) => !newKeys.includes(id)),
    ]);
    next.excludedKeys = Array.from(set);
  } else if (newKeys.length < next.includedKeys.length) {
    next.includedKeys = next.includedKeys.filter((id: any) => newKeys.includes(id));
  } else {
    const set = new Set([...next.includedKeys, ...newKeys]);
    next.includedKeys = Array.from(set);
  }
  setSelection(next);
};

export const onSelectCurrentPage = (
  selected: boolean,
  data: any[],
  forceOverride: boolean,
  selection: any,
  setSelection: (_: any) => any,
  rowKey: string,
) => {
  const next = { ...selection };
  if (selected) {
    if (selection.isSelectAll) {
      if (forceOverride) {
        next.isSelectAll = false;
        next.includedKeys = data.map(t => t[rowKey]);
        next.excludedKeys = [];
      } else {
        next.excludedKeys = next.excludedKeys.filter((id: any) => !data.find(t => t[rowKey] === id));
      }
    } else {
      const set = new Set([...next.includedKeys, ...data.map(t => t[rowKey])]);
      next.includedKeys = Array.from(set);
    }
  } else {
    if (selection.isSelectAll) {
      const set = new Set([...next.excludedKeys, ...data.map(t => t[rowKey])]);
      next.excludedKeys = Array.from(set);
    } else {
      next.includedKeys = next.includedKeys.filter((id: any) => !data.find(t => t[rowKey] === id));
    }
  }
  setSelection(next);
};

export const onSelectAllPage = (setSelection: any) => {
  setSelection({
    isSelectAll: true,
    includedKeys: [],
    excludedKeys: [],
  });
};

export const onClearAllPage = (setSelection: any) => {
  setSelection({
    isSelectAll: false,
    includedKeys: [],
    excludedKeys: [],
  });
};

export const formatDate = (value: number, format = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(value * 1000).format(format);
};
